import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import Dialog from '../../../../common/widgets/Dialog';
import Icons from '../../../../common/widgets/Icons';
import LoadingSpinner from '../../../../common/widgets/LoadingSpinner';
import { logTrace } from '../../../../common/telemetry/logTrace';
import { resources } from '../../resources/resources';

export const AuthenticationExpiredDialog = () => {
  const auth = useAuth();
  const { t: translate } = useTranslation();

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading) return;

    const timer = setTimeout(async () => {
      logTrace(
        'AuthenticationExpiredDialog: calling signoutRedirect',
        {
          isAuthenticated: auth.isAuthenticated,
          expiresAt: auth.user?.expires_at,
        },
        { flush: true },
      );
      // useAuth().signoutRedirect never throws: once the redirect starts it
      // never resolves, and on failure it returns null (the error is only
      // put in auth.error). Getting past this line means the signout failed.
      await auth.signoutRedirect();

      logTrace('AuthenticationExpiredDialog: signoutRedirect failed');
      try {
        await auth.removeUser();
      } catch (e) {
        console.error('Signout redirect failed, cleaning up locally:', e);
      }
      globalThis.location.assign('/');
    }, 7000);

    return () => clearTimeout(timer);
  }, [auth]);

  return (
    <Dialog className="dialog-s">
      <div className="dialog-content">
        <div className="dialog-image">
          <Icons.WarningRed />
        </div>
        <div className="dialog-title">
          {translate(resources.authenticationWarningDialogs.expired.title)}
        </div>
        <div className="dialog-text centered">
          {translate(resources.authenticationWarningDialogs.expired.body)}
        </div>
      </div>
      <div className="dialog-actions vertical">
        <LoadingSpinner size="medium" />
      </div>
    </Dialog>
  );
};
